import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL     = import.meta.env.VITE_SUPABASE_URL     as string;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY as string;


if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env");
}

// Standard anon client — used everywhere in the browser
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// Service-role client — only used for admin operations (e.g. provisioning shop auth users).
// The service key is already in the client bundle via SUPABASE_SERVICE_KEY.
export const supabaseAdmin = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: { autoRefreshToken: false, persistSession: false },
});

// ─── Type definitions matching the DB schema ───────────────────

export interface Profile {
  id: string;
  role: "supervisor" | "agent" | "admin";
  agent_id: string | null;
  name: string;
  avatar: string | null;
  zone: string | null;
  target: number;
  phone: string | null;
  internal_email: string | null;  // agent login email
  owner_id: string | null;        // which business this profile belongs to
  last_seen: string | null;       // agent presence tracking
  business_code: string | null;   // unique code owners share with agents for login
  business_name: string | null;   // business/company name
  is_active?: boolean;            // false = owner manually disabled
  plan_suspended?: boolean;       // true = system suspended due to plan agent limit
  onboarding_shown?: boolean;     // true = onboarding tour has been seen
  created_at: string;
  logo_url?: string | null;
}

export interface Product {
  id: string;
  name: string;
  sku: string;
  price: number;
  buying_price: number;
  total_stock: number;
  unit: string;
  created_at: string;
  image_url?: string | null;
}

export interface Allocation {
  id: string;
  agent_id: string;
  product_id: string;
  allocated: number;
  remaining: number;
  created_at: string;
  updated_at: string;
  // Joined fields
  product?: Product;
  agent?: Profile;
}

export interface Transaction {
  id: string;
  agent_id: string;
  product_id: string;
  quantity: number;
  amount: number;
  customer_phone: string | null;
  status: "ok" | "review";
  created_at: string;
  // Joined fields
  product?: Product;
  agent?: Profile;
}